import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { useNavigate } from 'react-router-dom';
import useAuth from '../auth/publicUsers/useAuth';
import { pushTokenSaveToken } from '../crud/PushTokenCrud';

const useRegisterPush = () => {
    const navigate = useNavigate()
    const { authentication } = useAuth()
    const handleRegister = (async () => {
        if (!Capacitor.isNativePlatform()) return;
        const perm = await PushNotifications.requestPermissions();
        if (perm.receive !== 'granted') return;

        await PushNotifications.register();

        PushNotifications.addListener('registration', async (token) => {
            console.log('FCM Token:', token.value);
            // Send token to backend

            let param = {
                id: 0,
                publicUserId: authentication.data.id,
                fcmToken: token.value
            }
            await pushTokenSaveToken(param)
        });

        PushNotifications.addListener(
            'pushNotificationActionPerformed',
            (notification) => {
                const route = notification.notification.data?.route;
                if (route) {
                    navigate(route)
                }
            }
        );
    })
    const handleRegisterDoctor = (async (did) => {
        if (!Capacitor.isNativePlatform()) return;
        const perm = await PushNotifications.requestPermissions();
        if (perm.receive !== 'granted') return;

        await PushNotifications.register();

        PushNotifications.addListener('registration', async (token) => {
            console.log('FCM Token:', token.value);
            // Send token to backend
            let param = {
                id: 0,
                doctorUserId: did,
                fcmToken: token.value
            }
            await pushTokenSaveToken(param)
        });

        PushNotifications.addListener(
            'pushNotificationActionPerformed',
            (notification) => {
                const route = notification.notification.data?.route;
                if (route) {
                    navigate(route)
                }
            }
        );
    })
    return {
        handleRegister,
        handleRegisterDoctor
    }
}

export default useRegisterPush